import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components'; // Mapeo de variantes a sus propiedades en el tema

var colorMap = {
  primary: function primary(theme) {
    return theme.colors.primary.normal;
  },
  secondary: function secondary(theme) {
    return theme.colors.secondary.normal;
  },
  extra: function extra(theme) {
    return theme.colors.extra.normal;
  },
  danger: function danger(theme) {
    return theme.colors.danger.normal;
  },
  gray0: function gray0(theme) {
    return theme.colors.grey0;
  },
  disabled: function disabled(theme) {
    return theme.colors.grey24;
  },
  gray36: function gray36(theme) {
    return theme.colors.grey36;
  },
  gray60: function gray60(theme) {
    return theme.colors.grey60;
  },
  gray84: function gray84(theme) {
    return theme.colors.grey84;
  }
};

var getColor = function getColor(variant, theme) {
  return colorMap[variant] ? colorMap[variant](theme) : theme.colors.grey84;
};

export var createText = function createText(props, theme) {
  return "\n    font-size: ".concat(theme.fontsV2[props.type].mobile[props.size].fontSize, "px;\n    line-height: ").concat(theme.fontsV2[props.type].mobile[props.size].lineHeight, "px;\n    font-weight: ").concat(theme.fontsV2.fontWeight[props.fontWeight], ";\n    color: ").concat(getColor(props.variant, theme), ";\n    margin: 0;\n\n    @media (min-width: ").concat(theme.screen.lgMin, ") {\n        font-size: ").concat(theme.fontsV2[props.type].desktop[props.size].fontSize, "px;\n        line-height: ").concat(theme.fontsV2[props.type].desktop[props.size].lineHeight, "px;\n    }\n");
};
export var ClickableContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));